import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import 'amfe-flexible'
import '@/assets/icons'
import svgIcon from '@/components/plugins/svgIcon.vue'
import { post, get } from './api/common.js'

import VueBus from 'vue-bus'

Vue.component('svgIcon', svgIcon)
Vue.use(VueBus)
Vue.prototype.$axios = axios
Vue.prototype.post = post
Vue.prototype.get = get
Vue.config.productionTip = false

new Vue({
	el: '#app',
	router,
	render: h => h(App),
}).$mount('#app')
